let currentScroll;

export function scrollPageTo(top, signal) {
  currentScroll?.abort();
  const controller = currentScroll = new AbortController();
  const start = window.scrollY;
  const destination = Math.max(0, Math.min(top, document.documentElement.scrollHeight - window.innerHeight));
  const distance = destination - start;
  if (signal?.aborted) {
    currentScroll = null;
    return Promise.resolve(false);
  }
  if (Math.abs(distance) < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo({ top: destination, behavior: 'instant' });
    currentScroll = null;
    return Promise.resolve(true);
  }
  return new Promise(resolve => {
    let frame;
    let started;
    let settled = false;
    const finish = completed => {
      if (settled) return;
      settled = true;
      cancelAnimationFrame(frame);
      signal?.removeEventListener('abort', cancel);
      controller.abort();
      if (currentScroll === controller) currentScroll = null;
      resolve(completed);
    };
    const cancel = () => finish(false);
    controller.signal.addEventListener('abort', cancel, { once: true });
    signal?.addEventListener('abort', cancel, { once: true });
    for (const name of ['wheel', 'touchstart', 'pointerdown']) {
      window.addEventListener(name, cancel, { passive: true, once: true, signal: controller.signal });
    }
    window.addEventListener('keydown', event => {
      if (['Escape', 'PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown', ' '].includes(event.key)) cancel();
    }, { signal: controller.signal });
    const step = time => {
      started ??= time;
      const progress = Math.min(1, (time - started) / 360);
      window.scrollTo({ top: start + distance * (1 - (1 - progress) ** 3), behavior: 'instant' });
      if (progress < 1) frame = requestAnimationFrame(step);
      else finish(true);
    };
    frame = requestAnimationFrame(step);
  });
}

document.addEventListener('click', async event => {
  const link = event.target.closest('a[data-footer-scroll]');
  if (event.defaultPrevented || !link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
  const target = document.getElementById(url.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  const clearance = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
  const arrived = await scrollPageTo(window.scrollY + target.getBoundingClientRect().top - clearance);
  if (!arrived || !target.isConnected) return;
  history.pushState(history.state, '', url.hash);
  const previous = target.getAttribute('tabindex');
  target.tabIndex = -1;
  target.focus({ preventScroll: true });
  target.addEventListener('blur', () => {
    if (previous === null) target.removeAttribute('tabindex');
    else target.setAttribute('tabindex', previous);
  }, { once: true });
});

window.addEventListener('pagehide', () => currentScroll?.abort());
